export type EarningDisplayStatus = 'pending' | 'available' | 'reversed';

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Mirror of the backend hold rule (summarizeAffiliateEarnings): an accrued
 * earning is withheld for 30 days after its payment, then available.
 * Reversed earnings (admin refund action) stay reversed forever.
 */
export function deriveEarningDisplayStatus({
  status,
  paymentDate,
  createdAt = null,
  releasesAt = null,
  now,
  holdDays = 30,
}: {
  status: string;
  paymentDate: Date | null;
  createdAt?: Date | null;
  releasesAt?: Date | null;
  now: Date;
  holdDays?: number;
}): EarningDisplayStatus {
  if (status === 'reversed') return 'reversed';
  if (releasesAt) return now.getTime() >= releasesAt.getTime() ? 'available' : 'pending';
  const baseDate = paymentDate || createdAt;
  if (!baseDate) return 'pending';
  const matured = now.getTime() - baseDate.getTime() >= holdDays * DAY_MS;
  return matured ? 'available' : 'pending';
}
